module.exports = __webpack_public_path__ + "static/media/logo.c37e438a.svg";